module.exports = __webpack_public_path__ + "img/vinosfera.84ab0753.jpg";